import React, { useState } from 'react';
import { Dialogs, Dialog, Pane, Content, Button, Text } from '@leverege/ui-elements';
import { Context, Config } from '@leverege/plugin';
import { DataSources } from '@leverege/ui-attributes';
import { LoadingScreen } from '@leverege/molten/screens';
import { TitleBar } from '@leverege/ui-plugin';
import RecovrSales from '../../util/RecovrSales';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default {
  id: 'recovr.voidSale',
  name: 'Void Sale',
  layout: {
    sort: 'item.void',
    sectionName: 'Sale Actions'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: 'location.sales',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'sale',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'company.locations.sales',
    objectType: 'sale'
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  handles: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets == null || targets.length === 0 || targets.length > 1) {
      return false;
    }
    return targets[0]?.data?.data?.state !== 'void';
  },
  appearance: () => {
    return {
      name: 'Void Sale',
      icon: 'https://recovr-ui-assets.storage.googleapis.com/void-sale-action.png'
    };
  },
  perform: async props => {
    const {
      context
    } = props;
    const sale = Context.getTargetsOfType(context, 'sale')[0];
    const actions = DataSources.getActions(sale);
    if (!sale) {
      return;
    }
    const parentPath = Config.get('VoidSale', 'saleLocationParentPath', 'location');
    const saleDate = sale?.data?.data?.date || Date.now();
    const voidWindow = Config.get('VoidSale', 'voidWindow', 21);
    const needForce = saleDate + 1000 * 60 * 60 * 24 * voidWindow < Date.now();
    let canForceVoid = false;
    if (needForce) {
      canForceVoid = await RecovrSales.canForceVoidSale({
        saleId: sale?.id,
        locationId: sale?.data?.data?.[parentPath]?.id,
        actions
      });
    }

    // only void-able for about 21 days
    // TODO: move to config
    let cmp;
    if (needForce && !canForceVoid) {
      cmp = props => {
        const {
          show,
          onClose
        } = props;
        const onOkay = () => {
          const saleType = sale?.data?.data?.type;
          const vin = sale?.data?.data?.vehicle?.vin;
          const locatorId = sale?.data?.data?.locator?.serialNumber;
          window.Intercom('showNewMessage',
          // eslint-disable-next-line max-len
          `Hello, I need help voiding a sale involving vehicle ${vin}${saleType === 'vehicle-with-locator' ? `and locator ${locatorId}` : ''}.`);
          onClose();
        };
        return /*#__PURE__*/_jsx(Dialog, {
          show: show,
          onClose: onClose,
          children: /*#__PURE__*/_jsxs(Content, {
            relative: true,
            children: [/*#__PURE__*/_jsx(Content.Header, {
              variant: "dialogHeader",
              children: /*#__PURE__*/_jsx(TitleBar, {
                variant: "dialogTitle",
                title: "Void Sale Forbidden",
                icon: "https://recovr-ui-assets.storage.googleapis.com/void-sale-action.png"
              })
            }), /*#__PURE__*/_jsx(Content.Area, {
              style: {
                minHeight: '120px'
              },
              variant: "dialogBody",
              children: /*#__PURE__*/_jsxs(Text, {
                variant: "body",
                "data-cy": Config.get('cypress', ['text', 'sales.voidSale'], 'text.sales.voidSaleMsg'),
                children: ["You cannot void a sale that is more than ", voidWindow, " days old. Please contact customer support via the help menu for assistance with this item."]
              })
            }), /*#__PURE__*/_jsxs(Content.Footer, {
              variant: "dialogFooter",
              layout: "flex:rowMEnd",
              children: [/*#__PURE__*/_jsx(Button, {
                variant: "tertiary",
                onClick: onClose,
                children: "Cancel"
              }), /*#__PURE__*/_jsx(Button, {
                onClick: onOkay,
                variant: "primary",
                children: "Contact Support"
              })]
            })]
          })
        });
      };
    } else {
      cmp = props => {
        const {
          show,
          onClose
        } = props;
        const [loading, setLoading] = useState(false);
        const onOkay = async () => {
          if (loading) {
            return;
          }
          setLoading(true);
          await RecovrSales.voidSale({
            saleId: sale?.id,
            locationId: sale?.data?.data?.[parentPath]?.id,
            actions,
            force: canForceVoid
          });
          setLoading(false);
          onClose();
        };
        return /*#__PURE__*/_jsx(Dialog, {
          show: show,
          onClose: onClose,
          children: /*#__PURE__*/_jsxs(Content, {
            relative: true,
            children: [/*#__PURE__*/_jsx(Content.Header, {
              variant: "dialogHeader",
              children: /*#__PURE__*/_jsx(TitleBar, {
                variant: "dialogTitle",
                title: "Void Sale",
                icon: "https://recovr-ui-assets.storage.googleapis.com/void-sale-action.png"
              })
            }), /*#__PURE__*/_jsx(Content.Area, {
              style: {
                minHeight: '120px'
              },
              variant: "dialogBody",
              children: loading ? /*#__PURE__*/_jsx(Pane, {
                children: /*#__PURE__*/_jsx(LoadingScreen, {
                  title: "Voiding Sale"
                })
              }) : /*#__PURE__*/_jsx(Text, {
                variant: "body",
                children: "Are you sure you want to void the Sale?"
              })
            }), /*#__PURE__*/_jsxs(Content.Footer, {
              variant: "dialogFooter",
              layout: "flex:rowMEnd",
              children: [/*#__PURE__*/_jsx(Button, {
                disabled: loading,
                variant: "secondary",
                onClick: onClose,
                children: "Cancel"
              }), /*#__PURE__*/_jsx(Button, {
                onClick: onOkay,
                variant: "primaryDestructive",
                "data-cy": Config.get('cypress', ['button', 'sales.voidSale'], 'button.sales.voidSale'),
                disabled: loading,
                children: "Void Sale"
              })]
            })]
          })
        });
      };
    }
    Dialogs.show({
      id: 'salesflow',
      component: cmp,
      props: {}
    });
  }
};